"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharingData = exports.BOOLEANS = void 0;
{ }
exports.BOOLEANS = [
    "enableLikes",
    "enableSharing",
    "enableBookmarking",
];
class SharingData {
    constructor(data) {
        this.enableLikes = false;
        this.enableSharing = false;
        this.enableBookmarking = false;
        this.sharingLink = null;
        this.sharingMessage = null;
        if (data) {
            data = (typeof data === "string") ? JSON.parse(data) : data;
            this.enableLikes = (null === data.enableLikes) ? false : data.enableLikes;
            this.enableSharing = (null === data.enableSharing) ? false : data.enableSharing;
            this.enableBookmarking = (null === data.enableBookmarking) ? false : data.enableBookmarking;
            this.sharingLink = data.sharingLink;
            this.sharingMessage = data.sharingMessage;
        }
    }
}
exports.SharingData = SharingData;
//# sourceMappingURL=SharingData.js.map